module.exports = __webpack_public_path__ + "img/ZR_Logo.78e3a2c5.svg";